<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="2"
            categoryName="Downhole Sensor"
            categorySectionIcon="fa-bolt"
            useActive
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'downhole-sensor',
    components: { BaseInventory }
}
</script>
